var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKebabMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5C1.15625 5.5 0.5 6.1875 0.5 7C0.5 7.84375 1.15625 8.5 2 8.5C2.8125 8.5 3.5 7.84375 3.5 7C3.5 6.1875 2.8125 5.5 2 5.5ZM0.5 2.25C0.5 3.09375 1.15625 3.75 2 3.75C2.8125 3.75 3.5 3.09375 3.5 2.25C3.5 1.4375 2.8125 0.75 2 0.75C1.15625 0.75 0.5 1.4375 0.5 2.25ZM0.5 11.75C0.5 12.5938 1.15625 13.25 2 13.25C2.8125 13.25 3.5 12.5938 3.5 11.75C3.5 10.9375 2.8125 10.25 2 10.25C1.15625 10.25 0.5 10.9375 0.5 11.75Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabMenuIcon);
export default __webpack_public_path__ + "static/media/kebab-menu-icon.d3fe8dc3.svg";
export { ForwardRef as ReactComponent };